import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { withErrorBoundary } from '@beef/react';
import { Banner } from '@carnica/ui-kit';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';

import { BreakpointEnum, RootState } from 'pages/MainPage/types';

import { MainCarouselProps } from './types';
import { MainCarouselItem } from './components/MainCarouselItem';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

// TODO: Надо будет сделать рефакторинг компонента, потому что щас слишком большой
const _MainCarouselBlock: React.FC<MainCarouselProps> = ({
  slides,
  duration = 3000,
  breakpoint,
}) => {
  const [visibility, setVisibility] = useState(true);
  const withControls = breakpoint >= BreakpointEnum.DESKTOP_1025;

  useEffect(() => {
    const handleScroll = () => {
      const triggerPoint = window.innerHeight * 0.33;
      const scrollPosition = window.scrollY;

      if (window.innerWidth > 800 && scrollPosition >= triggerPoint) {
        setVisibility(false);
      } else {
        setVisibility(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={cx('carousel', !visibility && 'hidden')}>
      <Banner
        autoPlay
        className={cx('carousel-swiper')}
        controlsResponseArea={400}
        duration={duration}
        infinite
        intersectionActivate={1}
        loop
        swiperOptions={{
          slideClass: cx('carousel-slide'),
          slidePrevClass: cx('carousel-slide-prev'),
        }}
        withControls={withControls}
      >
        {slides?.map((item, index) => (
          <MainCarouselItem
            bannerId={index + 1}
            bannerPosition={`${index + 1}/${slides.length}`}
            item={item}
            visibility={visibility}
          />
        ))}
      </Banner>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  breakpoint: state.breakpoint,
});

export const MainCarouselBlock = compose(
  withErrorBoundary({ fallback: null }),
  connect(mapStateToProps),
)(_MainCarouselBlock);
